/**
 * Canonical role names, mirroring the backend `ArabQuiz.Domain.Identity.Roles`
 * constants. Kept as a single source of truth so the "Admin" literal is never
 * duplicated across the admin guard, the header nav and any future role checks.
 */
export const Roles = {
  Admin: 'Admin',
} as const

export type RoleName = (typeof Roles)[keyof typeof Roles]
